var _style, _g, _g2, _circle, _circle2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 279.6",
    style: {
      enableBackground: "new 0 0 1920 279.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#BC202F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000047020233726412900570000003698689665084075177_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000079479304421265267400000010136844468590006951_"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M638,154.4c5.4,5.4,9.7,11.7,12.8,18.9s4.7,15.9,4.7,26.1c0,17.3-4.4,31.1-13.1,41.4 c-8.8,10.3-22.9,15.5-42.5,15.5c-14.2,0-25.5-2.3-34.1-7c-8.5-4.7-14.8-12.3-18.8-23c-4-10.6-5.9-25.1-5.9-43.4h41.6 c0,13.3,1.3,22.5,3.9,27.5c2.6,5,7,7.5,13.3,7.5c5.2,0,8.9-1.6,10.9-4.8c2.1-3.2,3.1-7.8,3.1-13.6c0-4.4-0.8-8.2-2.5-11.6 c-1.7-3.3-4.8-7.1-9.5-11.4c-4.7-4.3-11.7-9.8-21.1-16.7c-9.2-6.5-16.2-11.8-21.1-16.1c-4.9-4.3-9.1-10-12.7-17.2 c-3.5-7.2-5.3-15.9-5.3-26.1c0-15.6,4.5-28.4,13.4-38.4c9-10,22.7-15,41.3-15c37.7,0,56.6,22.5,56.6,67.5h-41.9 c0-10.8-1.2-18.4-3.6-22.7c-2.4-4.3-6.1-6.4-11.1-6.4c-4.2,0-7.4,1.4-9.7,4.2c-2.3,2.8-3.4,6.4-3.4,10.8c0,5.4,1.5,9.7,4.4,13 c2.9,3.2,9.1,8.3,18.4,15.2l9.7,7.2C625.2,142.7,632.6,149,638,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M705.9,253.2h-41.6V3.1h41.6V253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M721,32c-4.3-3.6-6.4-8-6.4-13c0-5.2,2.1-9.7,6.3-13.4C725,1.9,730.1,0,736.2,0c5.8,0,10.8,1.9,15,5.6 c4.2,3.8,6.3,8.2,6.3,13.4c0,5-2.1,9.3-6.3,13c-4.2,3.6-9.2,5.5-15,5.5S725.3,35.7,721,32z M756.8,253.2h-41.6V50h41.6V253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M932.5,53.6c4.8,4.5,8.1,11.3,9.8,20.5c1.8,9.2,2.7,21.6,2.7,37.2v141.9h-41.6V107.8c0-8.1-1-13.9-3.1-17.3 s-5.3-5.2-9.7-5.2c-9.4,0-14.1,7.6-14.1,22.8v145h-41.9V107.8c0-8.1-1-13.9-3-17.3s-5.2-5.2-9.5-5.2c-9.6,0-14.4,7.6-14.4,22.8 v145h-41.6V50h41.6v22.8c2.9-7.1,7.3-13.2,13.3-18.3c5.9-5.1,13.3-7.7,22-7.7c9,0,15.8,2.2,20.6,6.7s8.2,11.4,10.3,20.8 c3.1-7.7,8-14.2,14.7-19.5s14.4-8,23.1-8C920.8,46.9,927.7,49.1,932.5,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1050.6,154.4c5.4,5.4,9.7,11.7,12.8,18.9c3.1,7.2,4.7,15.9,4.7,26.1c0,17.3-4.4,31.1-13.1,41.4 c-8.8,10.3-22.9,15.5-42.5,15.5c-14.2,0-25.5-2.3-34.1-7c-8.5-4.7-14.8-12.3-18.8-23c-4-10.6-5.9-25.1-5.9-43.4h41.6 c0,13.3,1.3,22.5,3.9,27.5c2.6,5,7,7.5,13.3,7.5c5.2,0,8.9-1.6,10.9-4.8c2.1-3.2,3.1-7.8,3.1-13.6c0-4.4-0.8-8.2-2.5-11.6 c-1.7-3.3-4.8-7.1-9.5-11.4c-4.7-4.3-11.7-9.8-21.1-16.7c-9.2-6.5-16.2-11.8-21.1-16.1c-4.9-4.3-9.1-10-12.7-17.2 c-3.5-7.2-5.3-15.9-5.3-26.1c0-15.6,4.5-28.4,13.4-38.4c9-10,22.7-15,41.3-15c37.7,0,56.6,22.5,56.6,67.5h-41.9 c0-10.8-1.2-18.4-3.6-22.7c-2.4-4.3-6.1-6.4-11.1-6.4c-4.2,0-7.4,1.4-9.7,4.2c-2.3,2.8-3.4,6.4-3.4,10.8c0,5.4,1.5,9.7,4.4,13 c2.9,3.2,9.1,8.3,18.4,15.2l9.7,7.2C1037.8,142.7,1045.2,149,1050.6,154.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1163.5,50v38.4h-32.2V185c0,11.5,1.4,19.3,4.1,23.4c2.7,4.2,7.6,6.3,14.7,6.3h13.4v38.4H1140 c-14.4,0-25.2-2.2-32.4-6.7c-7.2-4.5-12-11.5-14.5-20.9c-2.5-9.5-3.8-23-3.8-40.5V88.5h-19.7V50c8.5-2.5,14.6-8.1,18.3-16.7 c3.6-8.6,5.4-18.7,5.2-30.2h41.6c0,11.7-1.9,21.9-5.6,30.8c-3.8,8.9-9.3,14.2-16.6,16.1H1163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1271,64.2c9.4,11.6,14.1,29.7,14.1,54.5v40.6h-72.8V186c0,12.3,1.1,20.7,3.4,25.2s6.5,6.7,12.5,6.7 s10.1-2.2,12.2-6.6c2.1-4.4,3.1-12.8,3.1-25.3v-12.5h41.6v10.9c0,24.8-4.7,43-14.1,54.5c-9.4,11.6-23.7,17.3-42.8,17.3 c-19.2,0-33.6-5.8-43.1-17.3c-9.6-11.6-14.4-29.7-14.4-54.5v-65.6c0-24.8,4.8-43,14.4-54.5c9.6-11.6,24-17.3,43.1-17.3 C1247.3,46.9,1261.6,52.7,1271,64.2z M1243.5,117.2c0-12.3-1.1-20.7-3.3-25.2c-2.2-4.5-6.2-6.7-12-6.7c-6,0-10.2,2.2-12.5,6.7 s-3.4,12.9-3.4,25.2v14.1h31.3L1243.5,117.2L1243.5,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1507.6,53.6c4.8,4.5,8.1,11.3,9.8,20.5c1.8,9.2,2.7,21.6,2.7,37.2v141.9h-41.6V107.8c0-8.1-1-13.9-3.1-17.3 s-5.3-5.2-9.7-5.2c-9.4,0-14.1,7.6-14.1,22.8v145h-41.9V107.8c0-8.1-1-13.9-3-17.3s-5.2-5.2-9.5-5.2c-9.6,0-14.4,7.6-14.4,22.8 v145h-41.6V50h41.6v22.8c2.9-7.1,7.3-13.2,13.3-18.3c5.9-5.1,13.3-7.7,22-7.7c9,0,15.8,2.2,20.6,6.7c4.8,4.5,8.2,11.4,10.3,20.8 c3.1-7.7,8-14.2,14.7-19.5s14.4-8,23.1-8C1495.9,46.9,1502.8,49.1,1507.6,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1629.8,64.2c9.4,11.6,14.1,29.7,14.1,54.5v40.6H1571V186c0,12.3,1.1,20.7,3.4,25.2s6.5,6.7,12.5,6.7 s10.1-2.2,12.2-6.6c2.1-4.4,3.1-12.8,3.1-25.3v-12.5h41.6v10.9c0,24.8-4.7,43-14.1,54.5c-9.4,11.6-23.7,17.3-42.8,17.3 c-19.2,0-33.6-5.8-43.1-17.3c-9.6-11.6-14.4-29.7-14.4-54.5v-65.6c0-24.8,4.8-43,14.4-54.5c9.6-11.6,24-17.3,43.1-17.3 C1606.1,46.9,1620.4,52.7,1629.8,64.2z M1602.3,117.2c0-12.3-1.1-20.7-3.3-25.2c-2.2-4.5-6.2-6.7-12-6.7c-6,0-10.2,2.2-12.5,6.7 s-3.4,12.9-3.4,25.2v14.1h31.3L1602.3,117.2L1602.3,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1753.9,53.6c5.2,4.5,8.8,11.4,10.8,20.6c2,9.3,3,21.6,3,37v141.9h-41.6V107.8c0-8.1-1.2-13.9-3.6-17.3 s-6.2-5.2-11.4-5.2c-5.6,0-9.7,1.8-12.3,5.5c-2.6,3.6-3.9,9.4-3.9,17.3v145h-41.6V50h41.6v22.8c3.1-7.1,7.7-13.2,13.8-18.3 c6-5.1,13.9-7.7,23.4-7.7C1741.4,46.9,1748.7,49.1,1753.9,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1873.3,154.4c5.4,5.4,9.7,11.7,12.8,18.9c3.1,7.2,4.7,15.9,4.7,26.1c0,17.3-4.4,31.1-13.1,41.4 c-8.8,10.3-22.9,15.5-42.5,15.5c-14.2,0-25.5-2.3-34.1-7c-8.5-4.7-14.8-12.3-18.8-23c-4-10.6-5.9-25.1-5.9-43.4h41.6 c0,13.3,1.3,22.5,3.9,27.5s7,7.5,13.3,7.5c5.2,0,8.9-1.6,10.9-4.8c2.1-3.2,3.1-7.8,3.1-13.6c0-4.4-0.8-8.2-2.5-11.6 c-1.7-3.3-4.8-7.1-9.5-11.4c-4.7-4.3-11.7-9.8-21.1-16.7c-9.2-6.5-16.2-11.8-21.1-16.1s-9.1-10-12.7-17.2 c-3.5-7.2-5.3-15.9-5.3-26.1c0-15.6,4.5-28.4,13.4-38.4c9-10,22.7-15,41.3-15c37.7,0,56.6,22.5,56.6,67.5h-41.9 c0-10.8-1.2-18.4-3.6-22.7c-2.4-4.3-6.1-6.4-11.1-6.4c-4.2,0-7.4,1.4-9.7,4.2c-2.3,2.8-3.4,6.4-3.4,10.8c0,5.4,1.5,9.7,4.4,13 c2.9,3.2,9.1,8.3,18.4,15.2l9.7,7.2C1860.5,142.7,1867.9,149,1873.3,154.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 334.9226,
    cy: 137.5013,
    r: 122.5953,
    gradientTransform: "matrix(1.0319 0 0 1.0319 59.7043 11.4169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6743,
    style: {
      stopColor: "#303490"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6756,
    style: {
      stopColor: "#34378D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6905,
    style: {
      stopColor: "#5D5772"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7068,
    style: {
      stopColor: "#827459"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7249,
    style: {
      stopColor: "#A28D44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    style: {
      stopColor: "#BEA232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    style: {
      stopColor: "#D4B323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7941,
    style: {
      stopColor: "#E5C018"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8268,
    style: {
      stopColor: "#F0C910"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8727,
    style: {
      stopColor: "#F7CF0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9D00A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 405.3,
    cy: 153.3,
    r: 126.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 405.3,
    cy: 153.3,
    r: 50.6
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.4,54.5c6,5.1,10.6,11.2,13.8,18.3V3.1h41.6v220c0,7.7,0.2,13.5,0.5,17.3c0.3,3.9,1.2,8.1,2.7,12.7h-36.3 c-3.1-2.1-5.3-5.4-6.6-10c-1.3-4.6-1.9-8.9-1.9-12.8c-3.1,7.1-7.7,13.2-13.8,18.3c-6,5.1-13.9,7.7-23.4,7.7 c-9.4,0-16.7-2.2-21.9-6.7s-8.8-11.4-10.8-20.6c-2-9.3-3-21.6-3-37v-80.6c0-15.4,1-27.8,3-37c2-9.3,5.6-16.1,10.8-20.6 s12.5-6.7,21.9-6.7C73.6,46.9,81.4,49.4,87.4,54.5z M70.2,195.4c0,8.1,1.1,13.9,3.4,17.3c2.3,3.4,6.1,5.2,11.6,5.2 c5.4,0,9.4-1.8,12-5.5c2.6-3.6,3.9-9.4,3.9-17.3v-86.9c0-7.9-1.3-13.7-3.9-17.3s-6.6-5.5-12-5.5s-9.3,1.7-11.6,5.2 c-2.3,3.4-3.4,9.2-3.4,17.3V195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.1,64.2c9.4,11.6,14.1,29.7,14.1,54.5v40.6h-72.8V186c0,12.3,1.1,20.7,3.4,25.2 c2.3,4.5,6.5,6.7,12.5,6.7s10.1-2.2,12.2-6.6c2.1-4.4,3.1-12.8,3.1-25.3v-12.5h41.6v10.9c0,24.8-4.7,43-14.1,54.5 c-9.4,11.6-23.7,17.3-42.8,17.3c-19.2,0-33.6-5.8-43.1-17.3c-9.6-11.6-14.4-29.7-14.4-54.5v-65.6c0-24.8,4.8-43,14.4-54.5 c9.6-11.6,24-17.3,43.1-17.3C229.4,46.9,243.7,52.7,253.1,64.2z M225.6,117.2c0-12.3-1.1-20.7-3.3-25.2s-6.2-6.7-12-6.7 c-6,0-10.2,2.2-12.5,6.7s-3.4,12.9-3.4,25.2v14.1h31.3v-14.1H225.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c46b9b8fd7a45382b74071dd30f4a886.svg";
export { ForwardRef as ReactComponent };